import { equals, IPromise } from "angular";
import { Rect } from "konva/lib/shapes/Rect";
import { IWhiteboardRendererContext } from "../whiteboard-renderer";
import { WhiteboardShapeStateType, IWhiteboardShapeState } from ".";
import { IShapeState, WhiteboardShape } from "./shape";

export interface IAsyncState extends IShapeState {
  type: "async";
  message: string;
  promise: IPromise<IWhiteboardShapeState>;
  original: IWhiteboardShapeState;
  metrics?: [];
}

/**
 * This is a temporary placeholder while the original shape
 * is being loaded to that we can more correctly calculate the
 * size of the shapes on the layer
 */
export class Async extends WhiteboardShape<IAsyncState> {
  static stateTypes: WhiteboardShapeStateType[] = ["async"];

  constructor(state: IAsyncState, context: IWhiteboardRendererContext) {
    super(state, context);

    this.add(new Rect({ width: 300, height: 150 }));
  }

  updateState(state: IAsyncState): boolean {
    let updated = false;
    if (!equals(this.state.position, state.position)) {
      this.position(state.position);
      updated = true;
    }

    return updated;
  }
}
